
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingEmail=(params)=>get('/api/v1/userreceivenew/paging',params)
export const deleteEmail=(body)=>destroy(`/api/v1/userreceivenew/delete`,body)
export const createEmail=(body)=>post('/api/v1/userreceivenew/create',body)
